(function(){

/* =====================================================================
   CONFIG — everything you'll want to edit lives here
   ===================================================================== */
const CONFIG = {
  brand: "InFlair",
  logo: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-87e3fe5f7b.png",
  offerUrl: "https://inflairskin.com/products/rejuvenate-face-serum-for-bundle-v22",
  // Badge on the first screen + CTA on the results screen. Put the real max saving in once confirmed.
  savingsBadge: "Unlock savings of up to $150",
  resultsCta: "See My Offer",
  savingsFootnote: "Savings based on bundle pricing; applies to multi-bottle supplies on the offer page. Prices may change. See offer page for details.",
  termsUrl: "https://inflairskin.com/policies/terms-of-service",
  privacyUrl: "https://inflairskin.com/policies/privacy-policy",
  productImage: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/5_Bottle1_30_Inflair.png?v=1787212768&width=900",
  // Optional: POST endpoint for the final submission (null = off). Payload mirrors the original quiz.
  submitUrl: null,
  // Optional progress endpoint (null = off): receives a snapshot on every step.
  progressUrl: null,
  storagePrefix: "inflair-quiz:v1",

  /* ---- Before / after screen (PLACEHOLDERS — swap in approved customer images + quotes) ---- */
  beforeAfters: [{"name": "Caroline, Texas", "weeks": "", "tags": ["Dark spots", "Uneven tone"], "quote": "", "before": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-37681aff43.jpg", "after": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-0fe0b21a72.jpg"}, {"name": "Mandy, South Dakota", "weeks": "", "tags": ["Eye wrinkles", "Crow's feet"], "quote": "", "before": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-8a92bb788d.jpg", "after": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-292153b3e8.jpg"}, {"name": "Miranda, North Carolina", "weeks": "", "tags": ["Fine lines", "Eye area"], "quote": "", "before": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-ae91271702.jpg", "after": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-1ec0758694.jpg"}, {"name": "Agatha, New Jersey", "weeks": "", "tags": ["Forehead lines", "Smile lines"], "quote": "", "before": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-9ca9fc1cda.jpg", "after": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-e183df0a80.jpg"}],
  beforeAfterSubtitle: "Real results from women who made INFLAIR part of their routine.",
  beforeAfterFootnote: "Individual results vary.",

  /* ---- Expert screen (PLACEHOLDER — fill in with your expert's approved details) ---- */
  expert: {
    name: "Dr Alison",
    credentials: "Dermatologist",
    photo: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-dc1c466c40.jpg",
    image: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-c11dec8471.jpg",
    paragraphs: [
      "Injectables like Botox® and fillers can work well, but the effect wears off, so most people need a top-up every few months.",
      "Every top-up is another appointment and another bill, and it adds up over time.",
    ],
  },

  /* ---- Optional per-option images (leave "" to use the built-in illustration) ---- */
  // Folder the generated images live in. Upload the inflair-quiz-images folder next to this file,
  // or to Shopify Files and paste that base URL here (keep the trailing slash).
  imageBase: "inflair-quiz-images/",
  images: {
    age: { "under-45": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-7def555c09.jpg", "45-54": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-c75df152b0.jpg", "55-64": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-1649311575.jpg", "65-plus": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-f91aee94cb.jpg" },
    // severity[ageValue][severityValue] — falls back to severity[*]
    severity: { "*": { light: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-629e2745e8.jpg", noticeable: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-267a8bac68.jpg", pronounced: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-8e50c0d5e5.jpg", deep: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-7b6e4ef6b3.jpg" } },
    areas: {
      forehead: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-481864e0ef.jpg", eyes: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-e3930710aa.jpg", "smile-lines": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-818fb844f5.jpg", mouth: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-b948852cf8.jpg",
      "upper-lip": "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-0b2f1fd43c.jpg", marionette: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-d7cbb80395.jpg", jawline: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-22c9f163a9.jpg", neck: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-e0000be594.jpg",
    },
    results: "https://cdn.shopify.com/s/files/1/0574/2949/1869/files/kquiz-e946200c48.jpg",
  },
};

/* =====================================================================
   QUIZ DEFINITION
   ===================================================================== */
const NOTHING_YET = "nothing-yet", NO_EVENTS = "no-events";
const AGE = [
  { value: "under-45", label: "Under 45" },
  { value: "45-54", label: "45–54" },
  { value: "55-64", label: "55–64" },
  { value: "65-plus", label: "65+" },
];
const SEVERITY = [
  { value: "light", label: "Mild", description: "Fine lines, skin still firm" },
  { value: "noticeable", label: "Moderate", description: "Visible lines, some firmness lost" },
  { value: "pronounced", label: "Advanced", description: "Deep-set lines, noticeable sagging" },
  { value: "deep", label: "Severe", description: "Deeply etched lines, significant sagging" },
];
const SEV_LABEL = { light: "Mild", noticeable: "Moderate", pronounced: "Advanced", deep: "Severe" };
const SEV_LEVEL = { light: 1, noticeable: 2, pronounced: 3, deep: 4 };
const AREAS = [
  { value: "mouth", label: "Mouth Wrinkles", description: "Lines of every kind" },
  { value: "marionette", label: "Marionette Lines", description: "Mouth corners down to chin" },
  { value: "smile-lines", label: "Nasolabial Folds", description: "From nose to mouth" },
  { value: "jawline", label: "Sagging Jowls", description: "Softening & jowls" },
  { value: "upper-lip", label: "Smoker's Lines", description: "Fine vertical lines" },
  { value: "neck", label: "Turkey Neck", description: "Loose or crepey skin" },
  { value: "forehead", label: "Forehead Wrinkles", description: "Horizontal lines & frown lines" },
  { value: "eyes", label: "Eye Wrinkles", description: "Crow's feet & under-eyes" },
];
const AREA_GOAL = {
  forehead: "Smoother-looking forehead",
  eyes: "Brighter, smoother-looking eye area",
  "smile-lines": "Softer-looking smile lines",
  mouth: "Smoother-looking mouth area",
  "upper-lip": "Smoother-looking upper lip",
  marionette: "Softer-looking marionette lines",
  jawline: "More defined-looking jawline",
  neck: "Firmer-looking neck",
};

const QUESTIONS = [
  { id: "age", hash: "age", progress: 5, kind: "question", answerKey: "age",
    title: "How Old Are You?", selection: "single", layout: "picture", options: AGE },
  { id: "concerns", hash: "skin-concerns", progress: 10, kind: "question", answerKey: "concerns",
    title: "What's Bothering You Most About Your Skin Lately?", subtitle: "Select all that apply",
    selection: "multiple", layout: "list", options: [
      { value: "lines-wrinkles", label: "Fine lines & wrinkles" },
      { value: "loss-of-firmness", label: "Skin that's lost its firmness" },
      { value: "spots-uneven-tone", label: "Dark spots & uneven tone" },
      { value: "dry-crepey", label: "Dryness & crepey texture" },
      { value: "dullness", label: "Dull, tired-looking skin" },
      { value: "thinning", label: "Thinner, less plump skin" },
    ] },
  { id: "problem-areas", hash: "focus-areas", progress: 14, kind: "question", answerKey: "problemAreas",
    title: "Where Would You Love to See the Biggest Change?", subtitle: "Select all that apply",
    selection: "multiple", layout: "picture", options: AREAS },
  { id: "severity", hash: "line-severity", progress: 19, kind: "question", answerKey: "severity",
    title: "How Would You Describe Your Wrinkles & Sagging?", subtitle: "Pick the closest match. Images are illustrations.",
    selection: "single", layout: "picture", options: SEVERITY },
  { id: "sun-exposure", hash: "sun-exposure", progress: 24, kind: "question", answerKey: "sunExposure",
    title: "How Much Sun Has Your Skin Seen Over the Years?", subtitle: "Think lifetime, not just this summer.",
    selection: "single", layout: "list", options: [
      { value: "lots", label: "Lots", description: "Years of sun with little protection", icon: "☀️" },
      { value: "quite-a-bit", label: "Quite a bit", description: "Outdoors often, protection now and then", icon: "🌤️" },
      { value: "some", label: "Some", description: "Usually protected", icon: "⛅" },
      { value: "very-little", label: "Very little", description: "Mostly indoors or covered up", icon: "☁️" },
      { value: "not-sure", label: "Not sure", icon: "🤷‍♀️" },
    ] },
  { id: "smoking", hash: "smoking", progress: 29, kind: "question", answerKey: "smoking",
    title: "Do You Smoke, or Have You in the Past?", selection: "single", layout: "list",
    why: "Smoking speeds up the visible signs of aging, especially the fine lines around the lips.",
    options: [
      { value: "yes", label: "Yes, regularly" },
      { value: "occasionally", label: "Occasionally" },
      { value: "quit", label: "I quit" },
      { value: "never", label: "Never" },
    ] },
  { id: "stress", hash: "stress", progress: 33, kind: "question", answerKey: "stress",
    title: "How Often Do You Feel Stressed?", selection: "single", layout: "list", options: [
      { value: "constantly", label: "Pretty much all the time", icon: "😰" },
      { value: "most-days", label: "Most days", icon: "😬" },
      { value: "now-and-then", label: "Now and then, when life gets busy", icon: "🙁" },
      { value: "rarely", label: "Hardly ever", icon: "😌" },
    ] },
  { id: "skin-tone", hash: "skin-tone", progress: 38, kind: "question", answerKey: "skinTone",
    title: "Which Shade Is Closest to Your Skin Tone?", selection: "single", layout: "list", options: [
      { value: "fair", label: "Fair", swatch: "#F6E0D2" },
      { value: "light", label: "Light", swatch: "#EFCDB0" },
      { value: "medium", label: "Medium", swatch: "#C08A6F" },
      { value: "tan", label: "Tan", swatch: "#8E5C40" },
      { value: "deep", label: "Deep", swatch: "#5B3722" },
      { value: "not-sure", label: "Not sure", icon: "🤷‍♀️" },
    ] },
  { id: "sensitive-skin", hash: "sensitive-skin", progress: 43, kind: "question", answerKey: "sensitiveSkin",
    title: "Would You Call Your Skin Sensitive?", selection: "single", layout: "list", options: [
      { value: "yes", label: "Yes" }, { value: "no", label: "No" }, { value: "not-sure", label: "Not sure" },
    ] },
  { id: "solutions-tried", hash: "solutions-tried", progress: 57, kind: "question", answerKey: "solutionsTried",
    title: "What Have You Already Tried?", subtitle: "Select all that apply",
    selection: "multiple", layout: "list", options: [
      { value: "retinoids", label: "Retinol or prescription retinoids", icon: "🧴" },
      { value: "creams", label: "Anti-aging moisturizers or night creams", icon: "🌙" },
      { value: "serums", label: "Anti-aging serums", icon: "💧" },
      { value: "supplements", label: "Collagen or beauty supplements", icon: "💊" },
      { value: "devices", label: "LED, microcurrent or other devices", icon: "✨" },
      { value: "other", label: "Something else", icon: "➕" },
      { value: NOTHING_YET, label: "Nothing yet", icon: "🤷‍♀️", exclusive: true },
    ] },
  { id: "solutions-experience", hash: "solutions-experience", progress: 62, kind: "question", answerKey: "solutionsExperience",
    title: "How Did Those Work Out for You?", selection: "single", layout: "list", options: [
      { value: "loved-it", label: "Loved the results", description: "Did what it promised", icon: "🌟" },
      { value: "a-little", label: "A little better", description: "Some change, less than I wanted", icon: "👍" },
      { value: "let-down", label: "A letdown", description: "Lots of money, very little change", icon: "😕" },
      { value: "no-change", label: "Nothing changed", icon: "❌" },
      { value: "irritation", label: "My skin reacted", description: "Redness, peeling or dryness", icon: "😣" },
    ] },
  { id: "clinic-treatments", hash: "professional-treatments", progress: 67, kind: "question", answerKey: "clinicTreatments",
    title: "Have You Had Any In-Office Treatments?",
    subtitle: "Such as injectables, fillers, microneedling, lasers or chemical peels.",
    selection: "single", layout: "list", options: [ { value: "yes", label: "Yes" }, { value: "no", label: "No" } ] },
  { id: "treatment-results", hash: "treatment-results", progress: 71, kind: "question", answerKey: "treatmentResults",
    title: "How Did You Feel About the Results?", selection: "single", layout: "list", options: [
      { value: "great", label: "Great", description: "I still go back regularly", icon: "🌟" },
      { value: "good-but-costly", label: "Good, but costly", description: "Hard to keep paying for", icon: "💸" },
      { value: "unnatural", label: "Not natural enough", description: "Looked frozen or overdone", icon: "🙁" },
      { value: "underwhelming", label: "Underwhelming", description: "Less change than I expected", icon: "😕" },
      { value: "bad-reaction", label: "Bad reaction", description: "Side effects or complications", icon: "⚠️" },
    ] },
  { id: "older-than-you-feel", hash: "how-you-feel", progress: 81, kind: "question", answerKey: "olderThanYouFeel",
    title: "Does Your Skin Ever Look Older Than You Feel?", selection: "single", layout: "list", options: [
      { value: "yes", label: "Yes" }, { value: "sometimes", label: "Sometimes" }, { value: "no", label: "No" },
    ] },
  { id: "desired-feeling", hash: "desired-feeling", progress: 86, kind: "question", answerKey: "desiredFeeling",
    title: "Imagine Loving What You See in the Mirror Again. How Would That Feel?",
    selection: "single", layout: "list", options: [
      { value: "confident", label: "More confident, every day", icon: "🙌" },
      { value: "like-myself", label: "Like myself again", icon: "💗" },
      { value: "beautiful", label: "Beautiful", icon: "💋" },
      { value: "all", label: "All of these", icon: "💫" },
    ] },
  { id: "upcoming-event", hash: "upcoming-event", progress: 90, kind: "question", answerKey: "upcomingEvent",
    title: "Is There Something Special Coming Up?",
    subtitle: "A date on the calendar makes it easier to stay consistent.",
    selection: "single", layout: "list", options: [
      { value: "birthday", label: "A birthday", icon: "🎂" },
      { value: "wedding", label: "A wedding", icon: "💍" },
      { value: "vacation", label: "A vacation", icon: "🏝️" },
      { value: "reunion", label: "A reunion", icon: "👯" },
      { value: "other", label: "Something else", icon: "⭐" },
      { value: NO_EVENTS, label: "Nothing planned right now", icon: "❌" },
    ] },
  { id: "event-date", hash: "event-date", progress: 95, kind: "question", answerKey: "eventDate",
    title: "When's the Big Day?", subtitle: "We'll map your routine to it.",
    selection: "single", layout: "date", options: [] },
];

const EXTRA = [
  { id: "saving-answers", hash: "saving-answers", progress: 19, kind: "loading", title: "Saving Your Answers…",
    rows: ["Reading your answers", "Mapping your focus areas"] },
  { id: "putting-together-results", hash: "building-profile", progress: 43, kind: "loading", title: "Building Your Skin Profile",
    rows: ["Reading your answers", "Weighing your lifestyle factors", "Matching you to a routine", "Getting your offer ready"] },
  { id: "preparing-results", hash: "preparing-plan", progress: 95, kind: "loading", title: "Preparing Your Plan…",
    rows: ["Building your 12-week routine", "Applying your bundle pricing"] },
  { id: "opening-offer", hash: "opening-offer", progress: 100, kind: "loading", title: "Opening Your Offer…",
    rows: ["Saving your plan", "Opening your offer"] },
  { id: "reviews", hash: "before-after", progress: 48, kind: "content", title: "Real Women, Real Results" },
  { id: "skin-profile", hash: "skin-profile", progress: 52, kind: "content", title: "Your Skin Profile" },
  { id: "clinic-catch", hash: "expert-take", progress: 76, kind: "content", title: "The Catch With In-Office Treatments" },
  { id: "results", hash: "your-plan", progress: 100, kind: "content", title: "Your 12-Week Plan Is Ready" },
];

const ORDER = ["age","concerns","problem-areas","severity","saving-answers","sun-exposure","smoking","stress",
  "skin-tone","sensitive-skin","putting-together-results","reviews","skin-profile","solutions-tried",
  "solutions-experience","clinic-treatments","treatment-results","clinic-catch","older-than-you-feel",
  "desired-feeling","upcoming-event","event-date","preparing-results","results","opening-offer"];

const DEFS = new Map([...QUESTIONS, ...EXTRA].map(s => [s.id, s]));
const STEPS = ORDER.map(id => { const s = DEFS.get(id); if (!s) throw Error("Missing step " + id); return s; });
const BY_ID = new Map(STEPS.map(s => [s.id, s]));
const BY_HASH = new Map(STEPS.map(s => [s.hash, s]));

/* =====================================================================
   LOGIC (mirrors the reference funnel's rules)
   ===================================================================== */
// Branch rules: return true when the step should be skipped.
function shouldSkip(id, a) {
  switch (id) {
    case "solutions-experience": return triedNothing(a);
    case "treatment-results":
    case "clinic-catch": return a.clinicTreatments !== "yes";
    case "event-date": return a.upcomingEvent === undefined || a.upcomingEvent === NO_EVENTS;
    default: return false;
  }
}
function triedNothing(a) { return (a.solutionsTried || []).includes(NOTHING_YET); }
function nextStep(id, a) {
  for (let i = ORDER.indexOf(id) + 1; i < ORDER.length; i++) if (!shouldSkip(ORDER[i], a)) return ORDER[i];
}
// Drop answers that no longer apply after a change upstream.
function cleanAnswers(a) {
  const t = { ...a };
  if (triedNothing(t)) delete t.solutionsExperience;
  if (t.clinicTreatments !== "yes") delete t.treatmentResults;
  if (t.upcomingEvent === NO_EVENTS) delete t.eventDate;
  return t;
}
// 4 skin-aging factors
function factors(a) {
  const f = [];
  if (a.age && a.age !== "under-45") f.push("Age");
  if (a.sunExposure === "lots" || a.sunExposure === "quite-a-bit") f.push("Sun exposure");
  if (["yes", "occasionally", "quit"].includes(a.smoking)) f.push("Smoking");
  if (a.stress === "constantly" || a.stress === "most-days") f.push("Stress");
  return f;
}
const TIERS = [
  { name: "Low", text: "#166534", bg: "#E8F8EE", pointer: "10%" },
  { name: "Moderate", text: "#5E6410", bg: "#F1F3D8", pointer: "37%" },
  { name: "Elevated", text: "#8A4B00", bg: "#FFF1DA", pointer: "63%" },
  { name: "High", text: "#A3302A", bg: "#FBE1DE", pointer: "90%" },
];
const EVENT_NAME = { birthday: "your birthday", wedding: "the wedding", vacation: "your vacation", reunion: "your reunion", other: "your big day" };
function eventLine(a, now = new Date()) {
  if (!a.eventDate || !a.upcomingEvent) return null;
  const name = EVENT_NAME[a.upcomingEvent] || "your big day";
  const weeks = Math.floor((new Date(a.eventDate + "T12:00").getTime() - now.getTime()) / 6048e5);
  if (!Number.isFinite(weeks) || weeks < 0) return null;
  if (weeks < 2) return name.charAt(0).toUpperCase() + name.slice(1) + " is almost here. Your routine can start today.";
  return "Start today and you'll be around " + weeks + " weeks into your routine by " + name + ".";
}
const areaLabel = v => (AREAS.find(o => o.value === v) || {}).label || v;

/* =====================================================================
   STATE, STORAGE, TRACKING
   ===================================================================== */
const K_ANS = CONFIG.storagePrefix + ":answers", K_SES = CONFIG.storagePrefix + ":session", K_QS = CONFIG.storagePrefix + ":query";
const ss = {
  get(k) { try { const v = sessionStorage.getItem(k); return v ? JSON.parse(v) : undefined; } catch { return undefined; } },
  set(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch {} },
};
function uuid() { try { return crypto.randomUUID(); } catch { return Date.now().toString(36) + Math.random().toString(36).slice(2); } }
function newSession() {
  return { sessionId: "iq_" + uuid(), startedAt: new Date().toISOString(), landingUrl: location.href,
    referrer: document.referrer || null, path: [] };
}
function validAnswers(raw) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return {};
  const out = {};
  for (const q of QUESTIONS) {
    const v = raw[q.answerKey]; if (v === undefined) continue;
    if (q.layout === "date") { if (typeof v === "string") out[q.answerKey] = v; continue; }
    const ok = new Set(q.options.map(o => o.value));
    if (q.selection === "single") { if (typeof v === "string" && ok.has(v)) out[q.answerKey] = v; continue; }
    if (Array.isArray(v) && v.every(x => ok.has(x)) && new Set(v).size === v.length) out[q.answerKey] = v;
  }
  return out;
}
function validSession(s) {
  return s && typeof s.sessionId === "string" && typeof s.startedAt === "string" && Array.isArray(s.path)
    && s.path.length <= 64 && s.path.every(p => BY_ID.has(p)) ? s : undefined;
}
function answersById(a) {
  const out = {};
  for (const q of QUESTIONS) {
    const v = a[q.answerKey];
    if (Array.isArray(v) ? v.length : typeof v === "string" && v) out[q.id] = Array.isArray(v) ? [...v] : v;
  }
  return out;
}
function track(event, data) {
  try { (window.dataLayer = window.dataLayer || []).push({ event, ...data }); } catch {}
}

// Step key from the hash, ignoring params a funnel appended after it (#age?utm_source=x).
const hashKey = () => location.hash.replace(/^#/, "").split(/[?&]/)[0];
// Incoming params (utm_*, fbclid, _gl…) kept in the URL for the whole quiz and forwarded to the offer page.
// A visit that brings its own params replaces the saved set; one with none (reload, back nav) reuses it.
const QS = (() => {
  const h = location.hash.replace(/^#/, ""), i = h.search(/[?&]/);
  const q = new URLSearchParams(i >= 0 ? h.slice(i + 1) : "");
  new URLSearchParams(location.search).forEach((v, k) => q.set(k, v));
  if (q.toString()) ss.set(K_QS, q.toString());
  return q.toString() ? q : new URLSearchParams(ss.get(K_QS) || "");
})();

let S; // { answers, currentId, session }
(function init() {
  const fromHash = BY_HASH.get(hashKey());
  let ses = validSession(ss.get(K_SES));
  if (!ses || (ses.completed && (!fromHash || fromHash.id !== "opening-offer"))) ses = newSession();
  const answers = ses === undefined ? {} : (ss.get(K_ANS)?.version === 1 ? validAnswers(ss.get(K_ANS).answers) : {});
  const path = ses.path[0] === "age" ? [...ses.path] : ["age", ...ses.path.slice(-63)];
  S = { answers: ses.completed ? answers : (ses.path.length ? answers : {}), currentId: path.at(-1) || "age", session: { ...ses, path } };
  if (fromHash) S = moveTo(S, fromHash.id);
  // Rewrite to /page?params#step. Later pushState("#step") calls are relative, so they keep the query.
  const qs = QS.toString(), url = location.pathname + (qs ? "?" + qs : "") + "#" + BY_ID.get(S.currentId).hash;
  if (url !== location.pathname + location.search + location.hash) history.replaceState({ quizStep: S.currentId }, "", url);
})();

function moveTo(st, id) {
  if (st.currentId === id) return st;
  const i = st.session.path.lastIndexOf(id);
  const path = i >= 0 ? st.session.path.slice(0, i + 1) : [...st.session.path, id].slice(-64);
  return { ...st, currentId: id, session: { ...st.session, path } };
}
function prevId(st) {
  return st.session.path.slice(0, -1).findLast(id => BY_ID.get(id)?.kind !== "loading");
}
function persist() {
  ss.set(K_ANS, { version: 1, answers: S.answers });
  ss.set(K_SES, S.session);
  if (CONFIG.progressUrl && !S.session.completed) {
    try {
      fetch(CONFIG.progressUrl, { method: "POST", mode: "cors", keepalive: true, headers: { "content-type": "application/json" },
        body: JSON.stringify({ quiz: "inflair", sessionId: S.session.sessionId, screen: S.currentId, path: S.session.path, answers: answersById(S.answers) }) }).catch(() => {});
    } catch {}
  }
}
function setState(next, push) {
  const changed = next.currentId !== S.currentId;
  S = next;
  if (changed && push) { history.pushState({ quizStep: S.currentId }, "", "#" + BY_ID.get(S.currentId).hash); window.scrollTo({ top: 0, behavior: "instant" }); }
  if (changed) track("quiz_step", { quiz_step: S.currentId, quiz_progress: BY_ID.get(S.currentId).progress });
  persist(); render();
}
function goNext() { const n = nextStep(S.currentId, S.answers); if (n) setState(moveTo(S, n), true); }
function goBack() { const p = prevId(S); if (p) setState(moveTo(S, p), true); }
function select(step, value) {
  let v = value;
  if (step.selection === "multiple") {
    const cur = S.answers[step.answerKey] || [];
    const excl = new Set(step.options.filter(o => o.exclusive).map(o => o.value));
    v = cur.includes(value) ? cur.filter(x => x !== value) : excl.has(value) ? [value] : [...cur.filter(x => !excl.has(x)), value];
  }
  setState({ ...S, answers: cleanAnswers({ ...S.answers, [step.answerKey]: v }) }, false);
}
function clearAndNext(step) {
  const a = { ...S.answers }; delete a[step.answerKey];
  const st = { ...S, answers: cleanAnswers(a) };
  const n = nextStep(st.currentId, st.answers);
  S = st; if (n) setState(moveTo(st, n), true); else { persist(); render(); }
}
window.addEventListener("popstate", () => {
  const s = BY_HASH.get(hashKey());
  if (s) { S = moveTo(S, s.id); persist(); render(); window.scrollTo({ top: 0, behavior: "instant" }); }
});
window.addEventListener("hashchange", () => {
  const s = BY_HASH.get(hashKey());
  if (s && s.id !== S.currentId) { S = moveTo(S, s.id); persist(); render(); }
});

/* =====================================================================
   RENDERING
   ===================================================================== */
const app = document.getElementById("app");
const img = u => !u ? "" : /^(https?:|data:|\/)/.test(u) ? u : CONFIG.imageBase + u;
const esc = s => String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const ARROW = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
const BACK = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
let timers = [];
function clearTimers() { timers.forEach(clearTimeout); timers = []; }

function shell(step, inner, footer) {
  const canBack = step.kind !== "loading" && prevId(S);
  return `
  <h1 class="sr-only">${esc(CONFIG.brand)} Skin Quiz</h1>
  <header class="hdr">
    <div class="hdr-row">
      ${canBack ? `<button class="back" aria-label="Back" data-act="back">${BACK}</button>` : "<span></span>"}
      <img class="logo" src="${CONFIG.logo}" alt="${esc(CONFIG.brand)}"><span></span>
    </div>
    <div class="bar" role="progressbar" aria-label="Quiz progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${step.progress}"><div style="width:${step.progress}%"></div></div>
  </header>
  <main class="${footer ? "" : "nofoot"}">${inner}</main>
  ${footer ? `<div class="foot"><div class="foot-in">${footer}</div></div>` : ""}`;
}
const head = (title, sub, eyebrow) => `<div class="head">${eyebrow ? `<p class="eyebrow">${esc(eyebrow)}</p>` : ""}<h2>${esc(title)}</h2>${sub ? `<p class="sub">${esc(sub)}</p>` : ""}</div>`;
const cta = (label, act = "next", disabled = false) => `<button class="cta" data-act="${act}" ${disabled ? "disabled" : ""}>${esc(label)} ${ARROW}</button>`;

/* --- built-in illustrations (used when no image URL is configured) --- */
const AGE_TINT = { "under-45": "var(--cream)", "45-54": "var(--soft)", "55-64": "var(--cream)", "65-plus": "var(--soft)" };
function ageVisual(o) {
  const url = CONFIG.images.age[o.value];
  if (url) return `<img src="${esc(img(url))}" alt="" loading="eager">`;
  return `<div class="ph" style="background:${AGE_TINT[o.value]}"><div class="big">${esc(o.label)}</div><div class="note">photo slot</div></div>`;
}
function sevVisual(age, v) {
  const set = CONFIG.images.severity[age] || CONFIG.images.severity["*"] || {};
  const url = set[v] || (CONFIG.images.severity["*"] || {})[v];
  if (url) return `<img src="${esc(img(url))}" alt="">`;
  const n = SEV_LEVEL[v];
  return `<div class="ph" style="background:var(--bg)"><div class="lvl">${[1,2,3,4].map(i => `<span class="${i <= n ? "f" : ""}"></span>`).join("")}</div><div class="note">photo slot</div></div>`;
}
// Simple original line-art face; the chosen zone is highlighted.
const ZONES = {
  forehead: '<ellipse cx="60" cy="34" rx="22" ry="8"/>',
  eyes: '<ellipse cx="42" cy="52" rx="9" ry="6"/><ellipse cx="78" cy="52" rx="9" ry="6"/>',
  "smile-lines": '<ellipse cx="46" cy="76" rx="5" ry="10"/><ellipse cx="74" cy="76" rx="5" ry="10"/>',
  mouth: '<ellipse cx="60" cy="86" rx="17" ry="9"/>',
  "upper-lip": '<ellipse cx="60" cy="79" rx="11" ry="4"/>',
  marionette: '<ellipse cx="47" cy="95" rx="5" ry="8"/><ellipse cx="73" cy="95" rx="5" ry="8"/>',
  jawline: '<path d="M33 88 Q40 110 60 112 Q80 110 87 88" fill="none" stroke-width="7"/>',
  neck: '<rect x="46" y="112" width="28" height="18" rx="6"/>',
};
function areaVisual(v) {
  const url = CONFIG.images.areas[v];
  if (url) return `<img src="${esc(img(url))}" alt="">`;
  return `<svg viewBox="0 0 120 130" aria-hidden="true">
    <g fill="rgba(178,4,32,.18)" stroke="#B20420" opacity=".95">${ZONES[v]}</g>
    <g fill="none" stroke="#020912" stroke-width="2" stroke-linecap="round">
      <path d="M60 14 C34 14 28 40 30 62 C32 90 44 110 60 112 C76 110 88 90 90 62 C92 40 86 14 60 14Z"/>
      <path d="M36 48 q6 -4 12 0 M72 48 q6 -4 12 0"/>
      <path d="M38 53 q4 2 8 0 M74 53 q4 2 8 0"/>
      <path d="M60 58 L57 72 q3 2 6 0"/>
      <path d="M50 84 q10 6 20 0"/>
      <path d="M48 112 L46 130 M72 112 L74 130"/>
    </g></svg>`;
}

function renderQuestion(step) {
  const a = S.answers;
  const raw = a[step.answerKey];
  const sel = Array.isArray(raw) ? raw : typeof raw === "string" ? [raw] : [];
  const isAge = step.id === "age";
  let body = "";
  if (step.layout === "picture") {
    body = `<div class="grid">${step.options.map(o => {
      const on = sel.includes(o.value);
      if (step.id === "problem-areas") return `<button class="area ${on ? "on" : ""}" aria-pressed="${on}" data-opt="${esc(o.value)}">
          <span class="top"><span class="check"></span></span><div class="face">${areaVisual(o.value)}</div>
          <span class="lb">${esc(o.label)}</span><span class="ds">${esc(o.description)}</span></button>`;
      const vis = isAge ? ageVisual(o) : sevVisual(a.age, o.value);
      return `<button class="pic ${isAge ? "arrow" : ""} ${on ? "on" : ""}" aria-pressed="${on}" data-opt="${esc(o.value)}">
          <div class="img">${vis}</div>
          <div class="cap"><span class="lb">${esc(o.label)}</span>${isAge ? ARROW : ""}${o.description ? `<span class="ds">${esc(o.description)}</span>` : ""}</div></button>`;
    }).join("")}</div>`;
  } else if (step.layout === "list") {
    const multi = step.selection === "multiple";
    body = `<div class="list">${step.options.map(o => {
      const on = sel.includes(o.value);
      return `<button class="opt ${on ? "on" : ""}" aria-pressed="${on}" data-opt="${esc(o.value)}">
        ${o.icon ? `<span class="ic" aria-hidden="true">${o.icon}</span>` : ""}
        ${o.swatch ? `<span class="sw" style="background:${o.swatch}"></span>` : ""}
        <span class="tx"><span class="lb">${esc(o.label)}</span>${o.description ? `<span class="ds">${esc(o.description)}</span>` : ""}</span>
        <span class="${multi ? "check" : "radio"}"></span></button>`;
    }).join("")}</div>`;
  } else if (step.layout === "date") {
    const today = new Date().toISOString().slice(0, 10);
    body = `<div class="date"><span aria-hidden="true">📅</span><label class="sr-only" for="event-date">Event date</label>
      <input id="event-date" type="date" min="${today}" value="${esc(sel[0] || "")}"></div>`;
  }
  const why = step.why ? `<div class="why"><b>Why we ask:</b><span>${esc(step.why)}</span></div>` : "";
  const intro = isAge ? `<div class="intro"><p>Take This 1-Minute Quiz to Find Your Routine</p><span class="pill">${esc(CONFIG.savingsBadge)}</span></div>` : "";
  const legal = isAge ? `<p class="fine">By continuing, you agree to our <a href="${esc(CONFIG.termsUrl)}" target="_blank" rel="noopener">Terms of Use</a> and acknowledge our <a href="${esc(CONFIG.privacyUrl)}" target="_blank" rel="noopener">Privacy Policy</a>.<br>${esc(CONFIG.savingsFootnote)}</p>` : "";
  let footer = "";
  if (step.selection === "multiple") footer = cta("Continue", "next", sel.length === 0);
  else if (step.layout === "date") footer = cta("Continue", "next", sel.length === 0) + `<button class="skip" data-act="skip">Skip this step</button>`;
  app.innerHTML = shell(step, intro + head(step.title, step.subtitle) + body + why + legal, footer);

  let auto = null;
  app.querySelectorAll("[data-opt]").forEach(b => b.addEventListener("click", () => {
    if (auto) clearTimeout(auto);
    select(step, b.dataset.opt);
    if (step.selection === "single" && step.layout !== "date") { auto = setTimeout(goNext, 250); timers.push(auto); }
  }));
  const inp = app.querySelector("#event-date");
  if (inp) inp.addEventListener("change", e => select(step, e.target.value));
}

function renderLoading(step) {
  const total = 700 * step.rows.length + 500;
  const final = step.id === "opening-offer";
  app.innerHTML = shell(step, `<div class="load">
    <div class="spin" role="status" aria-label="Loading"></div>
    <h2 aria-live="polite" style="text-align:center">${esc(step.title)}</h2>
    <div class="lbar" role="progressbar" aria-label="Loading progress"><div id="lb"></div></div>
    <ul class="rows">${step.rows.map(r => `<li><span class="dot"></span>${esc(r)}</li>`).join("")}</ul></div>`, "");
  const lb = document.getElementById("lb");
  timers.push(setTimeout(() => { lb.style.transition = `width ${total}ms linear`; lb.style.width = "100%"; }, 40));
  app.querySelectorAll(".rows li").forEach((li, i) => timers.push(setTimeout(() => li.classList.add("done"), 700 * (i + 1))));
  if (final) submitAndRedirect(total);
  else timers.push(setTimeout(goNext, total));
}

function offerHref() {
  const u = new URL(CONFIG.offerUrl);
  // Current URL first, then the saved copy (covers params another script stripped from the address bar mid-quiz).
  for (const q of [new URLSearchParams(location.search), QS]) q.forEach((v, k) => { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
  return u.toString();
}
function submitAndRedirect(total) {
  if (!S.session.completed) {
    const now = new Date(), start = Date.parse(S.session.startedAt);
    const payload = {
      quiz: "inflair", sessionId: S.session.sessionId, startedAt: S.session.startedAt, completedAt: now.toISOString(),
      durationMs: Number.isFinite(start) ? Math.min(864e5, Math.max(0, now - start)) : 0,
      landingUrl: S.session.landingUrl, referrer: S.session.referrer,
      query: Object.fromEntries(QS), path: S.session.path.slice(0, 64),
      answers: answersById(S.answers),
    };
    S = { ...S, session: { ...S.session, completed: true } }; persist();
    track("quiz_complete", { quiz_answers: payload.answers, quiz_factors: factors(S.answers).length });
    if (CONFIG.submitUrl) {
      try { fetch(CONFIG.submitUrl, { method: "POST", mode: "no-cors", keepalive: true, headers: { "content-type": "text/plain;charset=utf-8" }, body: JSON.stringify(payload) }).catch(() => {}); } catch {}
    }
  }
  timers.push(setTimeout(() => { window.__quizRedirect = offerHref(); if (!window.__quizNoRedirect) location.assign(window.__quizRedirect); }, total));
}

function renderReviews(step) {
  const cards = CONFIG.beforeAfters.map(r => {
    const slot = (url, label) => `<figure>${url ? `<img src="${esc(url)}" alt="${label} photo of ${esc(r.name)}" loading="lazy">` : `<div class="ba-ph">${label} photo<br>placeholder</div>`}<figcaption>${label}</figcaption></figure>`;
    return `<article class="card ba">
      <div class="ba-pics">${slot(r.before, "Before")}${slot(r.after, "After")}</div>
      <div class="ba-meta"><span class="ba-name">${esc(r.name)}</span></div>
      ${r.weeks ? `<span class="wk">${esc(r.weeks)}</span>` : ""}
      <div class="tags">${r.tags.map(t => `<span class="tag">${esc(t)}</span>`).join("")}</div>
      ${r.quote ? `<q>${esc(r.quote)}</q>` : ""}</article>`;
  }).join("");
  app.innerHTML = shell(step, head(step.title, CONFIG.beforeAfterSubtitle) + `<div class="ba-grid">${cards}</div><p class="fine">${esc(CONFIG.beforeAfterFootnote)}</p>`, cta("See My Skin Profile"));
}

function renderProfile(step) {
  const a = S.answers, f = factors(a);
  const tier = TIERS[Math.max(0, Math.min(3, f.length - 1))];
  const sev = a.severity || "noticeable";
  const areas = (a.problemAreas || []).map(areaLabel);
  const areaTxt = areas.length > 2 ? `${areas.slice(0, 2).join(", ")} +${areas.length - 2}` : areas.join(", ");
  const msg = f.length > 0
    ? `${f.length < 2 ? f[0] : `${f.slice(0, -1).join(", ")} and ${f.at(-1)}`} ${f.length > 1 ? "are all known to" : "is known to"} speed up visible skin aging, from fine lines to a loss of firmness.`
    : "None of the common factors came up. Skin still changes with age and hormones, so a consistent routine matters.";
  app.innerHTML = shell(step, head(step.title, "Built from your answers") + `
    <div class="prof">
      <section class="card">
        <div class="prof-h"><span>Skin-Aging Factors</span><span class="tier" style="color:${tier.text};background:${tier.bg};border-color:${tier.text}44">${tier.name}</span></div>
        <div class="sev-fig"><div class="box">${sevVisual(a.age, sev)}</div><small>Your self-rating: “${SEV_LABEL[sev]}”</small></div>
        <div class="meter" role="img" aria-label="${f.length} of 4 factors: ${tier.name}">
          <div class="segs"><div style="background:linear-gradient(90deg,#BFE9CF,#9ADBB3)"></div><div style="background:linear-gradient(90deg,#E6EEC4,#F2E9B0)"></div><div style="background:linear-gradient(90deg,#FFDFB8,#F8C18E)"></div><div style="background:linear-gradient(90deg,#F2A58E,#D9534A)"></div></div>
          <div class="knob" id="knob" style="left:0%"></div>
        </div>
        <div class="meter-l">${TIERS.map(t => `<span class="${t.name === tier.name ? "cur" : ""}">${t.name}</span>`).join("")}</div>
        <div class="fbox" style="background:${tier.bg}"><b style="color:${tier.text}">${f.length} of 4 common factors</b><p>${esc(msg)}</p></div>
      </section>
      <div class="tiles">
        <div class="tile"><span>Factors you mentioned</span><b>${esc(f.join(", ") || "—")}</b></div>
        <div class="tile"><span>Your self-rating</span><b>${SEV_LABEL[sev]}</b></div>
        <div class="tile"><span>Focus areas</span><b>${esc(areaTxt || "—")}</b></div>
        <div class="tile"><span>Your goal</span><b>Firmer, smoother-looking skin</b></div>
      </div>
    </div>
    <p class="fine">This profile is based only on your answers. It isn't a skin measurement, diagnosis or medical advice.</p>`, cta("Continue"));
  timers.push(setTimeout(() => { const k = document.getElementById("knob"); if (k) k.style.left = tier.pointer; }, 200));
}

function renderExpert(step) {
  const e = CONFIG.expert, filled = !!e.name;
  const paras = e.paragraphs.length ? e.paragraphs : ["[Expert paragraph 1: the point about in-office results needing repeat visits.]", "[Expert paragraph 2: how costs add up, and where an at-home routine fits.]"];
  app.innerHTML = shell(step, head(step.title) + `
    <section class="card expert">
      <div>
        <div class="ex-id">
          <div class="ex-av ${filled ? "" : "todo"}">${e.photo ? `<img src="${esc(e.photo)}" alt="${esc(e.name)}">` : "photo"}</div>
          <div><div style="font-weight:600;font-size:18px" class="${filled ? "" : "todo"}">${esc(e.name || "[Expert name, credentials]")}</div>
          <div style="font-size:14px;color:var(--ink-2)">${esc(e.credentials || "[Title · relationship to INFLAIR]")}</div></div>
        </div>
        <div class="ex-body ${e.paragraphs.length ? "" : "todo"}">${paras.map(p => `<p>${esc(p)}</p>`).join("")}</div>
      </div>
      <div class="ex-img ${e.image ? "" : "todo"}">${e.image ? `<img src="${esc(e.image)}" alt="">` : `<div class="ba-ph" style="border:0">Supporting image placeholder</div>`}</div>
    </section>`, cta("Continue"));
}

function renderResults(step) {
  const a = S.answers, f = factors(a), first = (a.problemAreas || [])[0], sev = a.severity, ev = eventLine(a);
  app.innerHTML = shell(step, head(step.title, "", "Your plan") + `
    <div class="res">
      <div style="display:flex;flex-direction:column;gap:20px">
        <ul class="ticks">
          ${ev ? `<li>${esc(ev)}</li>` : ""}
          <li>Rejuvenate Face Serum is made with 4DHA and Tremella mushroom to help skin look smoother, plumper and more hydrated.*</li>
          <li>One serum steps in for your day cream, night cream, eye cream and neck serum.</li>
          <li>Multi-bottle bundles give you the lowest price per bottle.</li>
        </ul>
        <div class="prod">${CONFIG.images.results ? `<img class="life" src="${esc(img(CONFIG.images.results))}" alt="Woman applying face serum">` : ""}<img class="bottle ${CONFIG.images.results ? "inset" : ""}" src="${esc(CONFIG.productImage)}" alt="INFLAIR Rejuvenate Face Serum"></div>
      </div>
      <div style="display:flex;flex-direction:column;gap:8px">
        <div class="cmp">
          <div class="col"><span class="badge" style="background:var(--soft)">Today</span>
            <div class="kv"><span>Focus area</span><b>${esc(first ? areaLabel(first) : "Overall skin")}</b></div>
            <div class="kv"><span>Your self-rating</span><b>${sev ? SEV_LABEL[sev] : "—"}</b><span class="bars">${[1,2,3,4].map(i => `<i class="${sev && i <= SEV_LEVEL[sev] ? "f" : ""}"></i>`).join("")}</span></div>
            <div class="kv"><span>Skin-aging factors</span><b>${f.length} of 4</b>${f.length ? `<ul class="chips">${f.map(x => `<li>${esc(x)}</li>`).join("")}</ul>` : ""}</div>
          </div>
          <div class="col"><span class="badge" style="background:var(--ink);color:#fff">12-week goal</span>
            <div class="kv"><span>Focus area</span><b>${esc((first && AREA_GOAL[first]) || "Smoother-looking skin")}</b></div>
            <div class="kv"><span>Overall look</span><b>Fresher & more radiant</b></div>
            <div class="kv"><span>Firmness goal</span><b>Firmer-looking skin</b></div>
          </div>
        </div>
        <p class="fine" style="margin-top:4px">Goals are not a prediction of your results. Individual results vary.</p>
      </div>
    </div>
    <p class="fine">*Cosmetic appearance only. Results vary and depend on consistent use as directed.<br>${esc(CONFIG.savingsFootnote)}</p>`,
    cta(CONFIG.resultsCta));
}

function render() {
  clearTimers();
  const step = BY_ID.get(S.currentId);
  if (step.kind === "question") renderQuestion(step);
  else if (step.kind === "loading") renderLoading(step);
  else ({ reviews: renderReviews, "skin-profile": renderProfile, "clinic-catch": renderExpert, results: renderResults })[step.id](step);
  app.querySelector('[data-act="back"]')?.addEventListener("click", goBack);
  app.querySelector('[data-act="next"]')?.addEventListener("click", goNext);
  app.querySelector('[data-act="skip"]')?.addEventListener("click", () => clearAndNext(step));
}
persist();
track("quiz_step", { quiz_step: S.currentId, quiz_progress: BY_ID.get(S.currentId).progress });
render();

})();